import { RevisionOperation } from "@components/revision-info/models/revision-operation.model";
import { ValueUnit } from "@models/enums/value-unit.enum";

export class RevisionInfo {
    public toolId: number;
    public toolName: string;
    public toolUid: string;
    public planType: ValueUnit;
    public productionValue: number;
    public operations: RevisionOperation[];

    constructor(revisionInfo: any = {}) {
        this.toolId = revisionInfo.toolId || null;
        this.toolName = revisionInfo.toolName || '';
        this.toolUid = revisionInfo.toolUid || '';
        this.planType = revisionInfo.planType || ValueUnit.Time;
        this.productionValue = revisionInfo.productionValue || 0;
        this.operations = (revisionInfo.operations || [])
            .map(operation => new RevisionOperation(operation));
    }
}
